import React, { createRef, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

import { Datatable } from "../../../shared/datatable/Datatable";
import { DropdownInput } from "../../../shared/form/FormInput";
import { postApi } from "../../../shared/services/apiHelper";
import { departmentList, locationList, runAssessmentList } from "../../../shared/settings/apiConfig";

import './Scheduler.scss';

const status = [
    {
        id: "Not Started",
        value: "Not Started",
    },
    {
        id: "In Progress",
        value: "In Progress"
    },
    {
        id: "Completed",
        value: "Completed"
    },
    {
        id: "Expired",
        value: "Expired",
    }
];

const filterMapping = {
    location: { field: 'locationid', value: '', op: '=', join: 'AND' },
    department: { field: 'departmentid', value: '', op: '=', join: 'AND' },
    status: { field: 'runstatus', value: '', op: '=', join: 'AND' },
    runname: { field: 'runname', value: '', op: 'LIKE', join: 'AND' },
    assessmentname: { field: 'assessmentname', value: '', op: 'LIKE', join: 'AND' },
};

const Scheduler = (props) => {

    const customAssessor = (data) => {
        return data.creatorfirstname + ' ' + data.creatorlastname;
    }
    
    const customDepartment = (value) => {
        return <span className="department-tag">{value}</span>
    };
    const customRender = (value) => {
        return <span className="department-tag">{value}</span>
    }

    const customAction = (row) => {
        return (
            <div className="d-flex gap-2">
                <div role={"button"} className="text-s action-link" onClick={()=>{  
                    props.history.push(`/scheduler/client/view/${row.id}`,{assessment:row})}}>View</div>
            </div>
        )
    };

    const [config, setConfig] = useState({
        name: 'run-assessment-list',
        url: runAssessmentList,
        columns: [
            { name: 'Assessor', property: null, sort: false, width: '15%', customColumn: customAssessor },
            { name: 'Assessment Cycle', property: 'runname', sort: false, width: '20%' },
            { name: 'Assessment Name', property: 'assessmentname', sort: false, width: '20%' },
            { name: 'Department', property: 'departmenttitle', sort: false, width: '25%', customColumn: customDepartment },
            { name: 'Run Status', property: 'runstatus', sort: false, width: '10%', customColumn: customRender },
            {
                name: '', property: '', width: '10%', columnType: 'actions', actions: {
                    header: <Button className="save-button" onClick={() => { props.history.push('/scheduler/add'); }}>+ Create</Button>,
                    row: [
                        { type: 'custom', action: customAction }
                    ]
                }
            }
        ],
        field: ["id", "runstatus", "runid", "runname", "runtype", "creatorid", "creatorfirstname", "creatorlastname", "assessmentid", "assessmentname", "departmentid", "departmenttitle","expirydate"],
        filter: [
            { field: 'runtype', value: 3, op: '!=', join: 'AND' }
        ],
        sort: [{ "field": "id", "direction": "desc" }],
        pagination: true,
    });
    const [location, setLocation] = useState([]);
    const [department, setDepartment] = useState([]);
    const [filterData, setFilterData] = useState(JSON.parse(JSON.stringify(filterMapping)));

    const dataTable = createRef();

    useEffect(() => {
        Promise.all([getLocationList(), getDepartmentList()]).then(responses => {
            setLocation(responses[0].map(elem => { return { ...elem, value: elem.title }; }));
            setDepartment(responses[1].map(elem => { return { ...elem, value: elem.title }; }));
        })
    }, []);

    const getDepartmentList = () => {
        let payload = {
            field: ["id", "title"],
            filter: []
        };
        return new Promise((resolve, reject) => {
            postApi(departmentList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const getLocationList = () => {
        let payload = {
            field: ["id", "title"],
            filter: []
        };
        return new Promise((resolve, reject) => {
            postApi(locationList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const onSearchChange = (name, value) => {
        let filters = [];
        setFilterData(prevState => {
            prevState[name].value = value;
            
            Object.keys(prevState).forEach(filter => {
                if ( prevState[filter].value ) {
                    filters.push({...prevState[filter]});
                } 
            });

            return {...prevState};
        });

        dataTable.current?.searchData([...filters]);
    }

    return (
        <div>
            <text className='screen-head'>Scheduler</text>
            <div className="scheduler-list">
            <div className='d-flex align-items-center gap-2'>
            <img className={"ms-2"} width={"25px"} src={`${process.env.PUBLIC_URL}/static/images/menu.png`} alt={"Assessments"} />
                <text className='screen-sub-head m-0'>Assessments</text>
            </div>
            <div className="filterview">
                <div className='d-flex align-items-end  gap-4 p-4 '>
                    <div className=" gap-2 align-items-center w-100">
                        {filterData.runname.value != "" && <div className="filterlable">Assessment Cycle</div>}
                        <Form.Control placeholder={"Assessment Cycle"} name='runname' defaultValue="runname" value={filterData.runname.value}  onChange={(event) => { onSearchChange('runname', event.target.value); }} />
                    </div>
                    <div className=" gap-2 align-items-center w-100">
                        {filterData.assessmentname.value != "" && <div className="filterlable">Assessment Name</div>}
                        <Form.Control placeholder={"Assessment Name"} name='assessmentname' defaultValue="assessmentname" value={filterData.assessmentname.value}  onChange={(event) => { onSearchChange('assessmentname', event.target.value); }} />
                    </div>
                    {/* <div className="d-flex gap-2 align-items-center w-100">
                        <div className="ffilterlable">Location</div>
                        <DropdownInput name='location' defaultValue="Location" value={filterData.location.value} options={location} onChange={(value) => { onSearchChange('location', value); }} />
                    </div> */}
                    <div className=" gap-2 align-items-center w-100">
                        {filterData.department.value != "" &&<div className="filterlable">Department</div>}
                        <DropdownInput name='department' defaultValue="Department" value={filterData.department.value} options={department} onChange={(value) => { onSearchChange('department', value); }} />
                    </div>
                    <div className=" gap-3 align-items-center w-100">
                        {filterData.status.value != "" && <div className="filterlable">Status</div>}
                        <DropdownInput name='status' defaultValue="Status" value={filterData.status.value} options={status} onChange={(value) => { onSearchChange('status', value); }} />
                    </div>
                </div>
            </div>

            <Datatable ref={dataTable} config={config} />
            </div>
        </div>
    );
}

export default Scheduler;